import { Building2, Mail, MessageCircle, Phone } from "lucide-react";
import { BRAND, waLink } from "@/data/content";
import LeadForm from "@/components/LeadForm";
import PayButton from "@/components/PayButton";

export default function Contact() {
  return (
    <>
      <section className="page-hero" data-testid="contact-hero">
        <div className="eyebrow gold">Contact Bima Bachat Bazar</div>
        <h1>Your next smart <span className="accent">move starts here.</span></h1>
        <p>Batayiye kya chahiye — hum WhatsApp par reply karenge aur aage ka process simple bana denge.</p>
      </section>
      <section className="section">
        <div className="detail-grid">
          <div className="contact-info" data-testid="contact-info">
            <div className="eyebrow blue">Let's talk</div>
            <h2>Seedhi baat, <span className="accent">sahi salah.</span></h2>
            <div className="contact-lines">
              <a href={`tel:+91${BRAND.phone1}`} data-testid="contact-phone-primary"><Phone size={17} /> {BRAND.phone1}</a>
              <a href={`tel:+91${BRAND.phone2}`} data-testid="contact-phone-secondary"><Phone size={17} /> {BRAND.phone2}</a>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp"><MessageCircle size={17} /> WhatsApp us</a>
              <a href={`mailto:${BRAND.email}`} data-testid="contact-email"><Mail size={17} /> {BRAND.email}</a>
            </div>
            <div className="address" data-testid="contact-address"><Building2 size={17} /><span>{BRAND.address}</span></div>
            <div className="map-frame" data-testid="office-map">
              <iframe
                title="Bima Bachat Bazar Office - Singh Market, Bindki"
                src="https://maps.google.com/maps?q=Singh%20Market%2C%20Bindki%2C%20Fatehpur%2C%20Uttar%20Pradesh%20212635&t=&z=15&ie=UTF8&iwloc=&output=embed"
                loading="lazy"
                allowFullScreen
              />
            </div>
            <div className="pay-inline" data-testid="consultation-pay">
              <p><strong>Priority consultation:</strong> 30-minute one-on-one session book karein.</p>
              <PayButton serviceKey="consultation" label="Book Consultation" amount={499} />
            </div>
          </div>
          <LeadForm />
        </div>
      </section>
    </>
  );
}
